module.exports = __webpack_public_path__ + "img/banner-3-2@1x.5ed3136e.jpg";